import React from 'react';
import { Alert } from 'react-bootstrap';

export default function PasswordRequirements() {
  
  return(
    <Alert variant="primary">
      <p>Please make sure the entered password meets the following requirements:</p>
      <ul>
        <li>Is between 8 and 99 characters long</li>
        <li>Contains at least one number</li>
        <li>Contains at least one upper- and lower-case letter</li>
        <li>
          Contains at least one of the following special characters: <br />
        <code>^ $ * . [ ] &#123; &#125; ( ) ? " ! @ # % &amp; / \ , &gt; &lt; ' : ; | _ ~ `</code>
        </li>
      </ul>
    </Alert>
  )
}
